// Vuetify
import { createVuetify } from 'vuetify'

export default createVuetify({
    icons: {
        defaultSet: 'mdi', // 預設圖示
    },
    theme: {
        cspNonce: document.querySelector('meta[name="csp-nonce"]').getAttribute('content')
    }
})